// extracted by mini-css-extract-plugin
module.exports = {"DropdownMenu":"DropdownMenu_DropdownMenu__VndfJ","DropdownMenuLink":"DropdownMenu_DropdownMenuLink__UTKOe"};